import { render, staticRenderFns } from "./FormulaTest.vue?vue&type=template&id=7b271d51&scoped=true"
import script from "./FormulaTest.vue?vue&type=script&lang=js"
export * from "./FormulaTest.vue?vue&type=script&lang=js"
import style0 from "./FormulaTest.vue?vue&type=style&index=0&id=7b271d51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b271d51",
  null
  
)

export default component.exports